var _defs, _path, _path2, _path3, _g, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 512,
    width: 512,
    id: "flag-icon-css-ni",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    y2: 283.42,
    x2: 500.626,
    y1: 289.055,
    x1: 498.738,
    gradientUnits: "userSpaceOnUse",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#510000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8a0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 287.449,
    x2: 502.927,
    y1: 291.373,
    x1: 501.444,
    gradientUnits: "userSpaceOnUse",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2a2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 317.647,
    x2: 484.764,
    y1: 311.709,
    x1: 484.764,
    gradientUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F5F549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97C924"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#04a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 317.486,
    x2: 634.411,
    y1: 317.486,
    x1: 444.509,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    id: "h"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 226.375l-63.702 110.332h127.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 444.509,
    y1: 317.486,
    x2: 634.411,
    y2: 317.486
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 444.509,
    y1: 317.486,
    x2: 634.411,
    y2: 317.486
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 444.509,
    y1: 317.486,
    x2: 634.411,
    y2: 317.486
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 444.509,
    y1: 317.486,
    x2: 634.411,
    y2: 317.486
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 484.764,
    y1: 311.709,
    x2: 484.764,
    y2: 317.647
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "x",
    gradientTransform: "scale(4.45715 .22436)",
    x1: 98.901,
    y1: 1440.155,
    x2: 124.971,
    y2: 1440.155,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 444.509,
    y1: 317.486,
    x2: 634.411,
    y2: 317.486
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 444.509,
    y1: 317.486,
    x2: 634.411,
    y2: 317.486
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 444.509,
    y1: 317.486,
    x2: 634.411,
    y2: 317.486
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 444.509,
    y1: 317.486,
    x2: 634.411,
    y2: 317.486
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 484.764,
    y1: 311.709,
    x2: 484.764,
    y2: 317.647
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "v",
    gradientUnits: "userSpaceOnUse",
    x1: 484.764,
    y1: 311.709,
    x2: 484.764,
    y2: 317.647
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "y",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(9.12405 .1096)",
    x1: 47.855,
    y1: 3054.214,
    x2: 61.745,
    y2: 3054.214
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0067c6",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 170.667h512v170.667H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M179.2 255.427l8.515.57c.03-.415.055-.83.084-1.245-1.117-.074-2.234-.15-3.35-.223.084-1.37.2-2.736.26-4.105 1.184-.857 2.37-1.713 3.55-2.575l.106-1.577c-1.25.906-2.497 1.813-3.745 2.72-.125-.887-.615-1.8-1.505-2.107-.78-.282-1.734-.332-2.41.225-.855.63-1.01 1.758-1.12 2.74-.15 1.856-.253 3.72-.385 5.577zm1.297-1.162c.102-1.397.166-2.798.3-4.193.104-.69.23-1.487.835-1.926.545-.362 1.352-.093 1.575.524.446 1.064.248 2.237.19 3.354l-.16 2.424c-.914-.06-1.83-.12-2.74-.183zm-.189-11.913l8.31 1.94 1.89-8.088-1.182-.276-1.606 6.88-2.53-.59 1.448-6.2-1.175-.275-1.448 6.2-2.238-.522 1.546-6.62c-.395-.094-.79-.186-1.186-.278l-1.83 7.83zm2.994-11.159l8.06 2.803.41-1.177c-1.058-.37-2.114-.736-3.17-1.104.413-1.22.866-2.426 1.247-3.656.27-1.004.482-2.178-.11-3.112-.48-.69-1.332-1.133-2.174-1.106-.93.04-1.686.723-2.098 1.515-.61 1.145-.95 2.405-1.395 3.618l-.77 2.218zm1.557-.778c.43-1.21.82-2.434 1.288-3.63.29-.64.644-1.398 1.38-1.6.604-.14 1.238.325 1.29.945.148 1.14-.35 2.216-.7 3.274l-.665 1.913-2.594-.902zm2.895-9.545c1.52.882 3.026 1.786 4.554 2.652.862.464 1.956.73 2.857.21 1.23-.68 2-1.938 2.603-3.164.476-1.033.822-2.316.215-3.37-.653-1.055-1.84-1.54-2.853-2.168l-2.95-1.726-.626 1.07c1.445.852 2.9 1.686 4.34 2.55.688.418 1.258 1.177 1.14 2.02-.136 1.005-.71 1.887-1.283 2.7-.47.658-1.264 1.19-2.106 1.01-.878-.167-1.592-.742-2.363-1.157l-2.9-1.697-.626 1.07zm6.146-10.044l6.777 5.186c1.052-1.373 2.1-2.75 3.16-4.117.607-.87 1.166-2.005.754-3.075-.373-.85-1.25-1.51-2.19-1.554-.424-.058-.977.263-1.207.405.242-.91-.503-1.764-1.34-2.005-1.01-.358-2.032.288-2.7 1.006-.785.855-1.44 1.817-2.16 2.727l-1.093 1.43zm1.72-.254c.792-1.016 1.543-2.066 2.374-3.052.387-.43 1.006-.917 1.606-.6.546.236.68.925.42 1.42-.414.888-1.098 1.607-1.668 2.394l-.93 1.217c-.6-.46-1.202-.918-1.803-1.378zm2.76 2.113c.823-1.053 1.598-2.144 2.467-3.16.443-.464 1-1.05 1.704-.915.602.138 1.04.79.832 1.396-.34 1.117-1.175 1.972-1.847 2.898l-1.06 1.384c-.698-.534-1.396-1.07-2.094-1.603zm3.204-10.91l5.86 6.203 5.02-4.743-.833-.88-4.014 3.793-.103.097-.074-.08-4.955-5.242zm7.513-6.573l5.2 6.765 1.016-.78-5.202-6.765zm7.643-5.19c-.844.525-1.524 1.14-2.047 1.856-.522.715-.803 1.46-.844 2.238-.042.778.166 1.53.624 2.267a4.39 4.39 0 0 0 1.687 1.574c.7.374 1.456.513 2.284.42.824-.092 1.754-.456 2.79-1.102.994-.62 1.7-1.333 2.133-2.154a3.675 3.675 0 0 0 .356-2.514l-1.18.463c.31 1.704-.79 2.523-2.023 3.305-1.927 1.173-3.805 1.088-4.956-.674-1.193-1.985.11-3.626 1.75-4.692 1.164-.726 2.31-1.223 3.403-.528l.924-.823c-.635-.44-1.358-.642-2.18-.596-.863.048-1.765.366-2.72.962zm10.083-5.032l-.894 9.562 1.328-.536.27-2.965h.004l4.317-1.742 2.248 1.95 1.33-.536-7.277-6.27-1.328.537zm1.167.98l2.837 2.456-3.177 1.28.34-3.736zm17.536-6.256l.533 8.517c1.54-.103 3.08-.175 4.62-.303 1.208-.138 2.507-.453 3.333-1.415 1.068-1.185 1.22-2.954.752-4.428-.392-1.298-1.56-2.28-2.88-2.528-1.3-.25-2.627-.053-3.937.007l-2.422.15zm1.314 1.133c1.226-.065 2.45-.184 3.677-.19a3.127 3.127 0 0 1 1.953.597c.854.584 1.355 1.634 1.243 2.667-.06 1.187-.933 2.278-2.086 2.578-.66.17-1.345.218-2.02.293l-2.386.15-.38-6.093zm10.58-1.637l-.487 8.52 8.292.473.07-1.21c-2.352-.134-4.703-.27-7.055-.403.05-.864.1-1.73.148-2.593 2.12.12 4.238.242 6.357.363l.07-1.205c-2.12-.12-4.24-.242-6.358-.363.043-.764.088-1.53.13-2.294 2.264.128 4.527.258 6.79.388l.07-1.217-8.027-.46zm22.28 3.555l-3.085 7.956 1.097.427 2.447-6.308.126-.33.136.365 2.943 8.464 1.437.556 3.086-7.956-1.1-.426-2.446 6.305-.125.32-.135-.36-2.947-8.46zm11.464 4.925l-3.88 7.6-1.14-.582 3.88-7.6zm6.436 3.77c-.828-.546-1.67-.908-2.54-1.085-.867-.175-1.662-.12-2.386.167-.724.288-1.322.79-1.8 1.515a4.39 4.39 0 0 0-.726 2.19c-.048.79.14 1.536.57 2.25.428.71 1.147 1.403 2.166 2.075.978.645 1.92.988 2.848 1.04.89.05 1.7-.193 2.434-.727l-.913-.88c-1.42.993-2.624.336-3.848-.457-1.87-1.263-2.577-3.005-1.456-4.786 1.307-1.913 3.342-1.413 4.995-.367 1.145.755 2.075 1.59 1.9 2.872l1.132.496c.134-.76.017-1.502-.367-2.23-.404-.765-1.07-1.452-2.01-2.073zm8.125 6.13l-8.92 3.557 1.082.94 2.762-1.11.003.003 3.515 3.05-.71 2.89 1.08.94 2.27-9.33-1.083-.94zm-.34 1.485l-.895 3.644-2.588-2.247 3.482-1.398zm6.785 4.443l-6.584 5.43c.264.32.53.64.793.962.862-.712 1.725-1.424 2.59-2.136.877 1.053 1.73 2.126 2.627 3.163-.274 1.436-.55 2.872-.817 4.31l1.006 1.22.858-4.548c.738.603 1.816.906 2.697.427.76-.358 1.426-1.047 1.465-1.926.092-1.175-.747-2.13-1.418-3l-3.216-3.902zm-.145 1.735c.922 1.14 1.89 2.242 2.77 3.413.406.603.912 1.452.446 2.157-.382.603-1.223.55-1.74.16-1.044-.704-1.734-1.782-2.55-2.718l-1.043-1.265 2.118-1.747zm10.128 11.847l-9.594.44.714 1.24 2.973-.144.003.005 2.32 4.035-1.618 2.498.715 1.242 5.2-8.074-.714-1.24zm-.81 1.29l-2.038 3.15-1.71-2.968 3.75-.18zm6.285 10.004c-.534-1.447-1.375-2.93-2.8-3.654-1.583-.796-3.692-.41-4.816.986-.978 1.16-1.028 2.8-.767 4.226.31 1.636 1.06 3.195 2.187 4.425-.212.076-.425.152-.637.23l.408 1.135c1.332-.48 2.665-.958 3.997-1.437l-1.554-4.316-.924.33c.38 1.06.762 2.122 1.144 3.182l-1.355.487c-1.193-1.027-1.86-2.544-2.206-4.053-.256-1.132-.266-2.49.592-3.38.986-1.024 2.732-1.343 3.915-.47 1.167.855 1.825 2.238 2.158 3.613.228.905.19 1.98-.496 2.686-.192.144.112.345.164.517l.327.538a3.01 3.01 0 0 0 1.146-2.385c.023-.908-.177-1.81-.482-2.66zm2.452 6.664l-4.774.928c-.885.173-1.55.453-1.992.827-.442.372-.724.897-.86 1.596-.136.69-.116 1.538.082 2.568a.21.21 0 0 1 .004.024c.203 1.03.502 1.823.887 2.413.388.597.847.978 1.396 1.157.55.18 1.27.192 2.157.02l4.772-.93-.237-1.216-4.657.905c-2.09.408-2.794-.692-3.153-2.574l-.005-.024c-.372-1.88-.132-3.164 1.958-3.57l4.658-.906-.237-1.218zm2.617 14.524l-8.83-3.776.103 1.43 2.74 1.162v.006l.337 4.64-2.544 1.547.103 1.43L332.8 251l-.103-1.428zm-1.29.812l-3.207 1.95-.247-3.418 3.453 1.468zm-145.592 21.262l-1.238.326 1.368 5.2 1.238-.327zm140.4 0l1.238.325-1.37 5.2-1.237-.326zm-127.203 21.891l-9.54 1.098.797 1.19 2.956-.35.003.006 2.592 3.866-1.443 2.604.797 1.19 4.633-8.413-.798-1.19zm-.718 1.345l-1.818 3.282-1.91-2.844 3.728-.438zm4.37 3.868l-6.082 5.688.812.868 5.126-4.793-2.69 7.4.932.995 7.35-2.23-5.034 4.706.812.868 6.082-5.687-1.234-1.32-7.468 2.23 2.796-7.225zm8.859 9.038l-5.134 6.817 6.634 4.996.73-.968-5.645-4.25 1.562-2.075 5.086 3.83.726-.963-5.086-3.83c.46-.612.92-1.224 1.382-1.836l5.433 4.09c.244-.324.488-.65.733-.973l-6.423-4.837zm8.349 6.112l-4.02 7.527c.367.196.734.39 1.1.588l1.58-2.96c1.213.638 2.412 1.304 3.635 1.922.294 1.432.587 2.865.887 4.295.465.25.93.497 1.395.745l-.94-4.532c.912.278 2.024.148 2.656-.63.537-.602.903-1.446.646-2.253-.3-1.112-1.395-1.695-2.32-2.233-1.537-.828-3.08-1.647-4.62-2.47zm.526 1.658c1.286.702 2.6 1.353 3.86 2.1.586.395 1.327.934 1.253 1.73-.064.697-.816 1.07-1.452.922-1.245-.207-2.296-.95-3.405-1.503-.516-.276-1.032-.55-1.548-.827l1.293-2.422zm9.112 3.38l-3.224 7.9 1.185.485 3.225-7.9zm7.695 2.659c-.942-.313-1.85-.444-2.735-.39-.883.057-1.636.316-2.26.782-.625.465-1.072 1.106-1.346 1.93a4.39 4.39 0 0 0-.133 2.3c.16.78.536 1.45 1.137 2.027.597.574 1.47 1.057 2.63 1.442 1.11.368 2.11.454 3.02.264a3.675 3.675 0 0 0 2.162-1.334l-1.11-.612c-1.116 1.327-2.45 1.005-3.837.556-2.133-.733-3.268-2.233-2.648-4.243.766-2.186 2.862-2.23 4.73-1.65 1.302.43 2.416.996 2.58 2.28l1.222.185c-.07-.77-.374-1.456-.934-2.06-.588-.633-1.41-1.123-2.478-1.478zm8.58 1.92l-5.58 7.816 1.417.205 1.723-2.427.006.002 4.607.666.964 2.817 1.42.205-3.137-9.077-1.418-.206zm.516 1.435l1.218 3.55-3.39-.49 2.173-3.06zm19.487-1.374c-.975.188-1.83.518-2.576 1-.743.48-1.272 1.075-1.59 1.787-.316.712-.392 1.49-.227 2.34.15.782.49 1.472 1.01 2.075.52.6 1.175 1 1.982 1.21.802.21 1.8.202 3-.03 1.15-.222 2.063-.636 2.762-1.247a3.675 3.675 0 0 0 1.232-2.22l-1.267.01c-.323 1.702-1.643 2.073-3.073 2.36-2.22.405-3.943-.347-4.386-2.404-.402-2.283 1.403-3.348 3.316-3.755 1.347-.26 2.595-.314 3.365.726l1.158-.436c-.437-.638-1.04-1.086-1.823-1.34-.823-.263-1.778-.29-2.884-.076zm5.698-1.008c.81 2.725 1.618 5.452 2.428 8.18l7.962-2.363-.345-1.162-6.772 2.01-.74-2.49 6.105-1.812c-.115-.386-.23-.77-.343-1.157l-6.104 1.812-.654-2.204 6.52-1.934-.347-1.17-7.71 2.29zm9.232-2.903l3.582 7.745c.356-.165.712-.33 1.07-.494l-2.99-6.46c2.763 1.253 5.51 2.543 8.265 3.81.183.16.367.053.55-.046.36-.165.717-.33 1.075-.497l-3.582-7.745-1.072.496 2.985 6.45c-2.835-1.285-5.656-2.605-8.486-3.905l-1.396.647zm9.37-4.401l.67 1.015 3.046-2.004.116-.077.058.087 3.965 6.025 1.036-.682-3.966-6.025-.058-.087.118-.078 3.063-2.016-.668-1.016zm8.586-5.88l5.784 6.276c.305-.28.61-.563.917-.844l-2.275-2.468c1.003-.935 2.027-1.846 3.014-2.798 1.45.194 2.898.39 4.348.578l1.162-1.07-4.588-.608c.563-.77.807-1.863.28-2.716-.4-.737-1.124-1.366-2.003-1.357-1.18-.028-2.086.862-2.92 1.58-1.24 1.142-2.48 2.286-3.72 3.426zm1.74.05c1.087-.983 2.135-2.01 3.256-2.953.58-.44 1.4-.99 2.13-.564.623.35.616 1.19.254 1.727-.645 1.084-1.685 1.833-2.576 2.7-.4.37-.802.74-1.203 1.108l-1.86-2.02zm8.188-9.986l3.817 8.813.907-1.11-1.19-2.728.002-.004 2.946-3.6 2.91.625.907-1.11-9.394-1.994-.908 1.11zm1.495.297l3.67.788-2.17 2.652-1.5-3.44zm2.221-5.131l7.16 4.643 3.757-5.796-1.017-.66-3.005 4.636-.077.118-.09-.058-6.053-3.925z",
    fill: "#c8a400"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "translate(-170.667) scale(.85333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 226.408l-31.478 54.535-15.42 26.702H546.9l-14.715-25.484L500 226.41z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 226.408l-2.356 4.082L500 285.467l2.358-54.977z",
    opacity: 0.62,
    fill: "#17c0eb",
    stroke: "#17c0eb",
    strokeWidth: 0.129
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 277.475l-.133.003.134 3.11.135-3.11c-.045 0-.09-.003-.134-.003z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#d",
    transform: "rotate(72 500 285.467)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#d",
    transform: "rotate(144 500 285.467)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#d",
    transform: "rotate(-144 500 285.467)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#d",
    transform: "rotate(-72 500 285.467)"
  })), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#e",
    transform: "rotate(8 500 285.467)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#e",
    transform: "rotate(16 500 285.467)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#e",
    transform: "rotate(24 500 285.467)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#e",
    transform: "rotate(32 500 285.467)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#e",
    transform: "rotate(40 500 285.467)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#e",
    transform: "rotate(48 500 285.467)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#e",
    transform: "rotate(56 500 285.467)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#e",
    transform: "rotate(64 500 285.467)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 265.844a44.236 44.236 0 0 0-28.97 10.75L456.376 302c-.5 2.67-.75 5.434-.75 8.25h5.03c0-21.726 17.62-39.344 39.345-39.344 21.727 0 39.344 17.618 39.344 39.344h5.03c0-2.813-.248-5.582-.75-8.25l-14.655-25.406a44.25 44.25 0 0 0-28.97-10.75z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 266.656c-11.764 0-22.44 4.675-30.28 12.25l-12.032 20.844a43.596 43.596 0 0 0-1.28 10.5h4.25c0-21.726 17.616-39.344 39.342-39.344 21.727 0 39.344 17.618 39.344 39.344h4.25a43.86 43.86 0 0 0-1.28-10.53l-12.032-20.814c-7.84-7.574-18.518-12.25-30.282-12.25z",
    fill: "#f60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 267.47c-12.702 0-24.1 5.52-31.938 14.31l-8.718 15.095a42.733 42.733 0 0 0-2.125 13.375h3.436c0-21.726 17.618-39.344 39.344-39.344 21.726 0 39.344 17.618 39.344 39.344h3.437c0-4.673-.74-9.165-2.124-13.375l-8.72-15.095c-7.835-8.788-19.236-14.312-31.937-14.312z",
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 268.25c-14.55 0-27.372 7.414-34.906 18.656l-2.813 4.875a41.818 41.818 0 0 0-4.28 18.47h2.656c0-21.726 17.617-39.344 39.343-39.344 21.726 0 39.343 17.618 39.343 39.344H542a41.82 41.82 0 0 0-4.282-18.437l-2.844-4.937C527.338 275.65 514.537 268.25 500 268.25z",
    fill: "#0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 269.062c-22.747 0-41.188 18.44-41.188 41.188h1.844c0-21.727 17.618-39.344 39.344-39.344 21.726 0 39.344 17.617 39.344 39.344h1.844c0-22.748-18.44-41.188-41.188-41.188z",
    fill: "#0cf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 269.844c-22.306 0-40.375 18.1-40.375 40.406h1.344c0-21.56 17.47-39.03 39.03-39.03 21.56 0 39.03 17.47 39.03 39.03h1.376c0-22.306-18.1-40.406-40.406-40.406z",
    fill: "#00f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 270.657c-21.863 0-39.588 17.725-39.588 39.59 0 .244.003.49.007.732h.8c-.005-.245-.007-.49-.007-.734 0-21.422 17.366-38.788 38.788-38.788 21.423 0 38.79 17.366 38.79 38.788 0 .245-.003.49-.008.733h.797c.003-.244.006-.49.006-.734 0-21.864-17.72-39.59-39.585-39.59z",
    fill: "purple"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.395 288.134c-.644-.124-1.226-.484-1.775-.61-.756.725-.835 1.457-.73 2.08.26.14.31.353.877.86s.496.773.462 1.965c-.016.502.07 1.58.578 1.68.548.11.932-.345 1.09-1.16.152-.79.417-1.215.698-1.7.306-1.853-.193-2.51-1.2-3.116z",
    fill: "#510000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.168 283.524c-.595.015-1.528 1.012-1.943.475-.24-.31-.28-.903-.037-1.4.56-1.152 1.124-1.717 2.167-2.33 2.378-1.402 3.89-.952 5.074 1.062 1.097 1.772 2.15 3.73 2.245 5.37.03.502.283 1.41-.156 1.86-1.35 1.39-4.597-1.434-6.498-.987-.64.15-1.377.617-1.98.218-.47-.31-.078-.997.272-1.294.612-.52 1.5-2.366 1.38-3.166-.067-.446-.08.18-.526.19z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.927 282.548c-1.083.445-.966 1.076-1.51 1.59.154.058.766.31 1.364-.3.26-.215.55-.294.678-.363-.305.22-.523.554-.684.684-.404.328-1.034 1.082-1.34 1.845-.307.764-.43 1.673-.376 1.782.056.11.426.78 1.566 1.232 2.03.806 2.417 2.438 4.477 2.438 1.615 0 1.356-1.056 2.647-.832 1.12.194 1.714-.696.636-1.232-1.37-.468-4.092-.192-5.372.033-.413-4.083-.055-2.65-.15-4.405-.098-1.755-.624-1.86.07-3.28-.577.87-1.276.733-2.003.806z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.938 279.795c-.04.223-.077.516-.056.6.087.34.175.693.278.994.115.335.162.578.24.927.082.36.4.5.694.722.37.28.084 1.036.315 1.067.183.025.487-1.07.49-1.246 0-.236-.002-.426-.038-.646a15.3 15.3 0 0 0-.426-.872c-.002-.004-.007-.006-.01-.01a3.652 3.652 0 0 0-.193-.327 4.204 4.204 0 0 0-.786-.863c-.02-.015-.037-.032-.056-.047a3.936 3.936 0 0 0-.258-.187c-.062-.04-.13-.076-.194-.113z",
    fill: "#ff2a2a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.25 287.398c-.72-.188-1.427-.543-2.038-.725-1.2-.36-2.48-1.134-3.366-.814-.317.14-.29.455-.39.91-.042.532-.596 1.318-.136 1.06.685-.382 2.49.734 3.095 1.107.287.177.892.524 1.082 1.022.19.497.092 1.755.04 2.295-.052.566.12 1.835.687 1.987.61.163 1.078-.323 1.316-1.23.23-.88.405-1.387.757-1.915s.756-.756 1.32-.863c.564-.106 1.382.462 1.382-.203 0-.436-.385-.854-.22-1.453.127-.472-.403-.378-.843-.572-1.036-.32-1.97-.42-2.688-.607z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.363 288.902c-.327-.178-2.315-1.478-3.043-1.07-.23.127-.317-.017-.32-.258-.004-.24.11-.594.184-.866.074-.273.195-.792.516-1.062.687-.58 2.27.575 3.108.886-.072.436-.47 2.356-.445 2.37z",
    fill: "#910000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.763 291.36c.916-1.602 1.508-1.396 2.613-1.373.37.008.477-.33.393-.667-.28.624-1.663-.07-2.416.263-1.573.692-1.28 3.77-2.027 4.07.776.65 1.124-1.746 1.436-2.292z",
    fill: "#ff3a3a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.103 307.645l-9.955 17.237h113.708l-9.956-17.237h-93.797z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "n",
    fill: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M449.705 321.364c-1.658 0-3.197.167-4.71.353l-.486.846c2.432-.216 4.696-.65 7.14-.71 3.292.08 6.282.83 9.785.83 1.518.015 3.027-.03 4.526 0 3.5 0 6.49-.75 9.784-.83 3.295.08 6.304.83 9.803.83 1.518.005 3.178-.023 4.53 0 3.5 0 6.474-.75 9.765-.83 3.293.08 6.27.83 9.77.83 1.53.015 3.032-.03 4.542 0 3.5 0 6.49-.75 9.787-.83 3.297.08 6.282.83 9.783.83 1.516.015 3.03-.03 4.53 0 3.5 0 6.475-.75 9.765-.83 2.55.063 4.92.52 7.486.725l-.515-.893c-1.404-.168-2.836-.32-4.37-.32-1.528-.022-3.035.03-4.546 0-3.5 0-6.474.747-9.765.828-3.297-.08-6.284-.83-9.787-.83-1.513-.02-3.03.032-4.526 0-3.5 0-6.493.75-9.786.83-3.293-.08-6.283-.83-9.782-.83-1.522-.02-3.042.032-4.547 0-3.498 0-6.475.75-9.764.83-3.294-.08-6.27-.83-9.77-.83-1.52-.02-3.025.032-4.525 0-3.5 0-6.49.75-9.785.83-3.294-.08-6.283-.83-9.783-.83-1.52-.02-3.043.032-4.547 0z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#k",
    y: -1.113,
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#k",
    y: -2.23,
    fill: "url(#m)"
  })), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#n",
    y: -3.344,
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#n",
    y: -6.691,
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.23 307.458l-.123.215h93.79l-.124-.215H453.23zm-.22.377l-.126.22h94.235l-.128-.22h-93.98zm-.2.346l-.204.357h94.792l-.205-.356H452.81zm-.317.552l-.25.433h95.518l-.25-.433h-95.017zm-.4.69l-.25.435h96.317l-.25-.434h-95.816zm-.398.692l-.247.43h97.107l-.247-.43h-96.613zm-.398.692l-.25.43h97.91l-.25-.43h-97.41zm-.43.744l-.304.53h98.877l-.303-.53h-98.27z",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.357 312.287c3.45.662 3.782 0 3.782 0zm81.503 0s.33.662 3.782 0z",
    fill: "url(#r)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ccd11e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M530.63 297.043c-1.708 0-2.23.862-2.23.862-2.737 10.576-11.808 21.333-22.6 21.333h-8.082v10.768c0 .003.012 0 .017 0h61.498l-6.187-10.954c-9.707-1.45-17.64-11.373-20.166-21.147 0 0-.54-.862-2.25-.862z",
    fill: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.63 297.465c-.783 0-1.26.18-1.537.355-.264.165-.315.276-.32.288 0 .007-.016.01-.02.016-1.4 5.323-4.35 10.67-8.333 14.707-4.012 4.07-9.07 6.83-14.605 6.83h-7.674v9.923h60.856l-5.68-10.058c-4.687-.612-8.973-3.163-12.458-6.694-3.986-4.037-6.932-9.383-8.334-14.706l-.017-.016c-.007-.012-.07-.105-.338-.27-.284-.177-.755-.373-1.54-.373z",
    fill: "#97c924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.63 297.465c.147 0 .28.02.406.034.024 3.016 0 8.108 0 10.8-.03 2.34-.83 4.223-2.012 6.44-.547 1.555-.986.964-2.35 2.858-1.83.654-3.186.91-5.138 1.216-2.517.398-8.12.75-10.887.136 3.64-1.068 6.96-3.27 9.77-6.12a30.57 30.57 0 0 0 2.13-2.4 33.663 33.663 0 0 0 3.01-4.48c.352-.626.686-1.248.997-1.893a33.86 33.86 0 0 0 1.25-2.94c.124-.33.245-.667.356-.998.222-.665.417-1.33.592-1.996.002-.006.015-.01.016-.017.007-.012.06-.122.322-.287.136-.085.332-.17.575-.237h.017c.252-.067.554-.118.946-.118z",
    fill: "#ede71f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.938 298.902c-.412 6.034-2.277 13.192-6.644 17.81-1.607 1.337-3.66 2.55-5.646 2.255 6.77-5.51 10.885-13.947 12.29-20.065z",
    fill: "#c6cb24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.494 309.28c-1.002 2.722-4.788 6.747-8.84 10.046-1.15.035-1.76.1-2.804.038 2.468-.225 8.22-5.083 11.644-10.083z",
    fill: "#9ecb34"
  })), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#t",
    x: -15.341
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#c6cb24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M502.218 297.91c2.735 10.576 11.79 21.334 22.583 21.334h8.09v10.768c0 .003-.015 0-.017 0h-65.795c-.006 0-.017.003-.017 0v-10.768h8.073c10.792 0 19.863-10.758 22.6-21.333 0 0 .534-.865 2.243-.865 1.708 0 2.243.866 2.243.866z",
    fill: "url(#u)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.975 297.465c.784 0 1.255.196 1.538.372.27.166.332.26.34.27l.016.017c1.4 5.323 4.347 10.67 8.332 14.707 4.017 4.07 9.087 6.83 14.623 6.83h7.64v9.923h-64.98v-9.923h7.675c5.535 0 10.593-2.76 14.605-6.83 3.982-4.037 6.934-9.383 8.334-14.706.002-.007.014-.01.016-.016.006-.012.057-.123.32-.288.28-.174.755-.355 1.54-.355z",
    fill: "#97c924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.263 297.53a3.4 3.4 0 0 0-.242.055h-.017c-.243.066-.436.15-.572.236-.263.166-.313.275-.32.287-.002.006-.016.01-.017.017a28.878 28.878 0 0 1-.949 2.993 34.22 34.22 0 0 1-1.25 2.942 34.21 34.21 0 0 1-.997 1.894 33.634 33.634 0 0 1-3.01 4.477 30.73 30.73 0 0 1-2.13 2.402c-2.81 2.85-6.128 5.05-9.77 6.117 2.766.614 4.033-.057 6.55-.455 1.952-.308 4.21-.563 6.043-1.217 1.364-1.894.9-1.3 1.446-2.854 1.18-2.218 2.906-4.222 3.334-6.68 1.62-3.023 1.903-8.615 1.903-10.214z",
    fill: "#ede71f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.275 298.902c-.412 6.034-2.277 13.192-6.644 17.81-1.605 1.337-3.66 2.55-5.645 2.255 6.77-5.51 10.885-13.947 12.29-20.065z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.832 309.28c-1.002 2.722-4.788 6.748-8.84 10.046-1.15.035-1.76.1-2.804.038 2.467-.225 8.222-5.083 11.644-10.083z",
    fill: "#9ecb34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.95 297.584h.02c.24.067.434.15.57.236.264.165.315.274.32.286.003.006.017.01.02.018.174.665.37 1.333.59 1.996.112.332.235.665.358.995a33.6 33.6 0 0 0 1.25 2.942c.31.645.644 1.268.997 1.895a33.634 33.634 0 0 0 3.01 4.477 30.73 30.73 0 0 0 2.13 2.4c2.81 2.85 6.128 5.446 9.768 6.513-7.245.028-10.39-.63-13.022-4.016-2.632-3.387-3.605-4.868-4.14-6.937-.534-2.068-2.025-6.57-1.87-10.806z",
    fill: "#ede71f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.476 298.902c.412 6.034 2.22 12.006 6.587 16.625 1.607 1.337 3.66 2.55 5.646 2.255-7.336-5.002-10.83-12.762-12.234-18.88z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M484.75 297.043c-1.71 0-2.25.862-2.25.862-2.522 9.747-11.824 22.318-21.496 23.81l-4.79 8.29h49.015V318.66c-8.826-2.37-15.89-11.63-18.25-20.753 0 0-.522-.862-2.23-.862z",
    fill: "url(#v)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.75 297.465c-.785 0-1.256.196-1.54.372-.268.166-.33.26-.337.27l-.017.017c-1.402 5.323-4.678 10.705-8.08 14.99-3.402 4.283-9.72 8.617-14.042 9.076l-4.282 7.393h48.06V318.89c-3.554-1.09-6.8-3.267-9.552-6.06-3.982-4.037-6.934-9.383-8.334-14.706-.002-.007-.015-.01-.017-.016-.007-.012-.06-.123-.322-.288-.28-.174-.755-.355-1.54-.355z",
    fill: "#97c924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.445 298.903c-.617 9.043-5.653 20.454-11.34 22.42-1.855.64-5.1.864-6.227 1.008 9.948-4.73 15.828-15.852 17.567-23.427z",
    fill: "#93bc30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.746 297.465c-.147 0-.28.02-.406.034-.023 3.016 0 8.108 0 10.8.03 2.34.83 4.223 2.012 6.44.07.195.136.355.203.49.41 1.087.713 1.464 2.282 2.655 4.987 3.787 11.17 4.353 14.808 4.04-1.14-.898-2.358-1.715-3.43-2.467 1.71-.056 3.35-.25 4.512-.508-3.64-1.067-6.96-3.27-9.77-6.12a30.523 30.523 0 0 1-1.403-1.554c-.21-.292-.5-.698-.592-.812-1.118-1.4-2.263-2.947-3.145-4.513a34.164 34.164 0 0 1-.997-1.893 34.023 34.023 0 0 1-1.606-3.938 31.676 31.676 0 0 1-.592-1.996c-.002-.006-.015-.01-.017-.017-.006-.012-.057-.122-.32-.287a2.207 2.207 0 0 0-.576-.237h-.018a3.614 3.614 0 0 0-.946-.118z",
    fill: "#ede71f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.446 298.902c.412 6.034 2.277 13.192 6.644 17.81 1.606 1.337 3.66 2.55 5.646 2.255-6.77-5.51-10.886-13.947-12.29-20.065z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.613 307.247c2.37 5.837 8.37 11.29 14.543 14.954 1.15.036 1.492.004 2.537-.06-4.42-2.37-11.54-5.753-17.08-14.893z",
    fill: "#9ecb34"
  })), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#w",
    x: -15.43,
    fill: "#c6cb24"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M556.5 324.692c-.574.203-4.42-.19-6.433-.044l-1.28.336c-1.123-.008-2.238.024-3.33 0-3.602 0-6.65.948-10.075.948-3.433 0-6.47-.948-10.075-.948-1.12-.008-2.234.025-3.33 0-3.602 0-6.647.948-10.076.948-3.428 0-6.472-.948-10.074-.948-1.13-.007-2.242.023-3.348 0-3.602 0-6.632.948-10.058.948-3.43 0-6.456-.948-10.058-.948-.267 0-.516.01-.776.017-.178-.003-.377-.016-.557-.016-.12 0-.223-.003-.34 0-.117-.003-.237 0-.356 0-.18 0-.345.013-.523.017-.258-.007-.51-.016-.778-.016-3.606 0-6.643.95-10.076.948-3.43 0-6.473-.948-10.075-.948-.26 0-.52.01-.775.017-.18-.003-.34-.016-.522-.016-.124 0-.252-.003-.374 0-.118-.003-.238 0-.357 0-.18 0-.362.013-.54.017-.26-.007-.51-.016-.776-.016-2.88 0-6.218.607-8.936.85l-6.272 10.858 62.972-.007 64.375.007z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.993 323.11c-.2 0-.398 0-.596.008-3.24.095-5.564 1.115-11.2 1.115-5.638 0-6.22-1.02-12.584-.88-5.947.132-8.443 1.263-11.67 1.218-3.228-.043-8.473-.696-12.51-.274-4.037.423-8.828 1.284-11.973 1.29-3.91-.016-7.82-.73-11.906-.323-4.087.406-5.997 1.5-11.063 1.485-4.355-.013-9.082-.698-12.745-.695-3.435.003-7.267.957-10.086 1.443l-.844 1.464c2.247-.26 8.55-1.218 10.802-1.277 2.344-.06 10.717.483 15.335.325 4.618-.16 5.158-1.172 10.618-1.172 3.802 0 6.667.4 10.567.4 2.434 0 4.643-1.243 8.343-1.243.936-.027 1.865-.06 2.794-.09 3.12-.516 8.384.044 12.048.23 3.315.174 5.457-.614 8.914-.73 1.496-.067 2.998-.065 4.474-.147 3.46-.115 6.422.64 9.68.624 3.25-.2 6.403-.922 9.86-1.037 1.51-.07 2.998-.072 4.49-.148 2.287-.076 5.837.078 8.273.5l-.84-1.45c-2.38-.075-5.31-.634-8.18-.634z",
    fill: "url(#x)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    id: "z",
    d: "M450.312 334.748c-3.457 0-6.402.853-9.652.945-1.21-.033-2.367-.183-3.535-.345l-.49.85c.486.032.975.063 1.488.063 1.502.02 2.99-.035 4.474 0 3.457 0 6.382-.85 9.634-.944 3.255.092 6.207.945 9.667.945 1.5.02 2.993-.035 4.474 0 3.458 0 6.413-.852 9.667-.944 3.256.092 6.23.945 9.687.945 1.495.02 2.993-.035 4.47 0 3.457 0 6.4-.852 9.652-.944 3.253.092 6.19.945 9.65.945 1.51.02 2.998-.035 4.49 0 3.457 0 6.41-.852 9.666-.944 3.257.092 6.21.945 9.67.945 1.495.02 2.99-.035 4.47 0 3.456 0 6.4-.852 9.65-.944 3.254.092 6.21.945 9.667.945 1.5.02 2.995-.035 4.473 0 .605 0 1.196-.033 1.778-.076l-.462-.797c-1.064.144-2.133.276-3.235.306-3.254-.092-6.195-.945-9.652-.945-1.51-.02-2.996.03-4.49 0-3.457 0-6.396.853-9.648.945-3.257-.09-6.206-.945-9.666-.945-1.496-.02-2.993.03-4.473 0-3.458 0-6.413.853-9.667.945-3.254-.092-6.21-.945-9.666-.945-1.503-.02-3.003.03-4.49 0-3.458 0-6.4.853-9.65.945-3.253-.092-6.194-.945-9.65-.945-1.507-.02-2.99.03-4.475 0-3.46 0-6.41.854-9.666.945-3.255-.092-6.21-.945-9.667-.945-1.502-.02-3.006.03-4.49 0z",
    fill: "url(#y)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#z",
    y: -1.289
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#z",
    y: -2.575
  })), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#A",
    y: -3.867
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#A",
    y: -7.729
  })), /*#__PURE__*/React.createElement("path", {
    d: "M443.846 324.705l-2.427 4.19c2.838-.47 7.1-1.702 10.633-1.705 3.663-.003 8.082.903 12.438.916 5.067.014 6.977-1.08 11.064-1.485 4.086-.406 7.998.528 11.906.546 3.145-.007 7.936-1.09 11.973-1.512 4.037-.422 7.737.293 12.603.37 4.866.074 5.63-1.18 11.576-1.312 6.366-.14 6.947.878 12.584.878 4.242.23 7.883-.854 11.666-1.12 3.784-.27 5.54.042 8.305.108l-1.838-3.253c-.032 0-.062.003-.093.004l-101.246 2.225z",
    fill: "#97c924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.067 324.648s2.71.148 3.847.276a91.39 91.39 0 0 0 2.955.253l-.37-.485c-.574.203-4.42-.19-6.433-.044z",
    fill: "#fff"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256 191.892l-27.428 47.52-28.038 48.553 54.867-.006 56.066.005-27.437-47.516L256 191.89zm0 2.562l26.922 46.637 26.326 45.592-53.847-.003-52.65.002 26.93-46.63z",
    fill: "#c8a400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNi);
export default __webpack_public_path__ + "static/media/ni.c9e542cdc749193cb1d4527b4dfb84be.svg";
export { ForwardRef as ReactComponent };